<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="navigation-products-container">
  <div class="flex w-full flex-col items-center justify-center py-6">
    <h2 class="mb-4 text-2xl font-semibold">Welcome to accesso Developers Portal</h2>
  </div>
  <div class="section-header">
    <h2>Product guides & references</h2>
    <p class="max-w-2xl">Find product guides, code samples, API documentation, and more.</p>
  </div>

  <div #searchBox class="search-box" [class.scrolled]="isSearchBoxScrolled">
    <div class="search-header">
      <h4>All Products ({{ navigationProducts.length }})</h4>
    </div>

    <div class="input-group">
      <div class="search-container">
        <ud-input #searchInput inputType="text" [label]="'Find Product documentation'" (onInput)="onSearch($event)">
          <i class="pi pi-search" left-icon></i>
        </ud-input>
        <div class="search-results-count" *ngIf="searchQuery">
          <span>{{ totalRecords }} matches</span>
        </div>
      </div>

      <p-paginator [rows]="rows" [first]="first" [totalRecords]="totalRecords" (onPageChange)="onPageChange($event)"> </p-paginator>
    </div>

    <!-- Active filters summary -->
    <div class="active-filters" *ngIf="selectedTagIds.length > 0 || searchQuery">
      <span class="active-filters-label">Active filters:</span>

      <div class="active-filter-item" *ngIf="searchQuery">
        <ud-chip [label]="'Search: ' + searchQuery" [removable]="true" (onRemove)="clearSearch()"></ud-chip>
      </div>

      <div class="active-filter-item" *ngFor="let tag of getSelectedTags()">
        <ud-chip [label]="tag.name" [removable]="true" (onRemove)="removeSelectedTag(tag.id)"></ud-chip>
      </div>

      <button class="clear-all-btn" (click)="clearFilter()">Clear all</button>
    </div>
  </div>

  <div class="products-with-filters">
    <!-- Tags sidebar on the left -->
    @if (tags && tags.length > 0) {
      <div class="tags-sidebar">
        <div class="sidebar-header">
          <h4 class="filter-heading">Product category</h4>
        </div>

        <div class="tags-list" role="list" aria-label="Product categories">
          <div
            *ngFor="let tag of tags"
            class="tag-item"
            [class.selected]="isTagSelected(tag.id)"
            (click)="toggleTag(tag.id)"
            [attr.aria-pressed]="isTagSelected(tag.id)"
            role="button"
            tabindex="0"
            (keydown.enter)="toggleTag(tag.id)"
          >
            <span class="tag-name">{{ tag.name }}</span>
            <span class="tag-count">({{ getTagCount(tag.id) }})</span>
          </div>
        </div>
      </div>
    }

    <!-- Product cards on the right -->
    <div class="products-content" #productContainer [class.compact-view]="isCompactView">
      <div class="card-container" *ngIf="displayedProducts.length > 0">
        <div
          *ngFor="let product of displayedProducts"
          class="product-card"
          (click)="navigateToProduct(product)"
          tabindex="0"
          role="button"
          [attr.aria-label]="product.name"
        >
          <app-product-card-item [product]="product"></app-product-card-item>
        </div>
      </div>
      <div class="no-results" *ngIf="displayedProducts.length === 0">
        <div class="flex flex-col items-center justify-center p-8 text-center">
          <i class="pi pi-search mb-4 text-4xl opacity-50"></i>
          <h3 class="mb-2 text-xl font-semibold">No matches found</h3>
          <p class="mb-4 text-gray-600">Try searching again with different keywords or clear the filters.</p>
          <ud-button [variant]="'outline'" (onClick)="clearFilter()">Clear filter</ud-button>
        </div>
      </div>
    </div>
  </div>
</div>
